import Seo from '@/components/Seo';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { MapPin, Phone, Mail } from 'lucide-react';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo title="Impressum | SR-Zerspanung" description="Impressum und Anbieterkennzeichnung der SR-Zerspanung, Stamsried." path="/impressum" noindex />
      <Header />
      
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-8">
            Impressum
          </h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground">
            {/* Verantwortlich */}
            <section className="mb-8">
              <p className="text-foreground font-medium">
                Inhaltlich verantwortlich gemäß § 10 Absatz 3 des MDstV: Thomas Schindler
              </p>
            </section>

            {/* Firmendaten */}
            <section className="mb-8 bg-card rounded-xl p-6 border border-border">
              <h2 className="font-heading font-bold text-2xl text-foreground mb-4">S&R Zerspanung</h2>
              <p className="text-foreground mb-4">Inhaber: Thomas Schindler</p>
              
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                  <span>Bernbachstr. 9<br />93491 Stamsried</span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                  <a href="tel:+4994669115130" className="hover:text-primary transition-colors">
                    09466 / 911 51 30
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                  <a href="mailto:thomas.schindler@sr-zerspanung.de" className="hover:text-primary transition-colors">
                    thomas.schindler@sr-zerspanung.de
                  </a>
                </div>
              </div>
              
              <p className="mt-4 pt-4 border-t border-border">
                <span className="text-foreground font-medium">Ust.ID:</span> DE304208929
              </p>
            </section>

            {/* Rechtliche Hinweise */}
            <section className="mb-8">
              <h2 className="font-heading font-bold text-xl text-foreground mb-4">Rechtliche Hinweise</h2>
              <p>
                Wir sind bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von uns selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.
              </p>
              <p className="mt-4">
                Bei einer Verletzung von fremden Urheberrechten oder sonstiger Rechte durch den Seitenbetreiber oder des Autors, ist auf die Verletzung schriftlich per eMail oder Brief hinzuweisen. Bei Bestehen einer Verletzung wird diese umgehend beseitigt.
              </p>
              <p className="mt-4">
                Das Copyright für veröffentlichte Objekte bleibt allein bei uns. Vervielfältigungen oder Verwendung von Grafiken, Tondokumenten, Videosequenzen und Texte in elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung nicht gestattet.
              </p>
            </section>

            {/* Haftungshinweise */}
            <section className="mb-8">
              <h2 className="font-heading font-bold text-xl text-foreground mb-4">Haftungshinweise</h2>
              
              <h3 className="font-heading font-bold text-lg text-foreground mt-6 mb-3">1. Inhalt des Onlineangebotes</h3>
              <p>
                Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, die sich auf Schäden materieller oder ideeller Art beziehen, welche durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.
              </p>
              <p className="mt-4">
                Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
              </p>

              <h3 className="font-heading font-bold text-lg text-foreground mt-6 mb-3">2. Rechtlicher Hinweis zu den dargestellten Links</h3>
              <p>
                Das Landgericht Hamburg hat mit Urteil vom 12. Mai 1998 entschieden, dass durch das Setzen eines Links ggf. Mitverantwortung gegenüber der gelinkten Seite besteht. Das Gericht führte aus, dass nur ein ausdrücklicher Hinweis, sich von den Inhalten dieser Seiten zu distanzieren, Mitverantwortung ausschließt.
              </p>
              <p className="mt-4">
                Für die auf diesen Seiten gelisteten Links gilt daher folgendes: Wir haben keinerlei Einfluss auf Inhalt und Form der ausgewählten Seiten und übernehmen daher keinerlei Verantwortung für Form und Inhalt anderer Anbieter. Dies gilt für alle auf unseren Seiten gesetzten Links zu anderen Anbietern. Sofern es sich um gewerbliche Anbieter handelt, stellt die Nennung hier keinerlei Empfehlung dar und es wird keine Aussage zu den Produkten getroffen.
              </p>

              <h3 className="font-heading font-bold text-lg text-foreground mt-6 mb-3">3. Rechtswirksamkeit dieses Haftungsausschlusses</h3>
              <p>
                Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Impressum;